import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/contest/findAll')
    return data
  },

  async get(id) {
    const { data } = await repository.get(baseURL + '/contest/' + id)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/contest', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/contest', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/contest/' + id)
  }
}
